var render, staticRenderFns
import script from "./report.vue?vue&type=script&lang=js&"
export * from "./report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b6bc96')) {
      api.createRecord('44b6bc96', component.options)
    } else {
      api.reload('44b6bc96', component.options)
    }
    
  }
}
component.options.__file = "found/views/sfa/views/interview/interview_comment_report/report.vue"
export default component.exports